const initialState = {
    defaultRules: [],
    defaultRulesForSelectionBox: [],
    applicationRuleNames: [],
    applicationRulesNamesForSelectionBox: [],
    defaultMatchingTypes: [],
    sourceColumns: [],
    targetColumns: [],
    matchingMappings: [],
    predictedRule: []
};


export default initialState;